import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Hämta från localStorage vid start
    const storedToken = localStorage.getItem("token");
    const storedAdmin = localStorage.getItem("isAdmin") === "true";
    if (storedToken) {
      setToken(storedToken);
      setIsAdmin(storedAdmin);
    }
  }, []);

  const login = (newToken, adminFlag) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("isAdmin", adminFlag);
    setToken(newToken);
    setIsAdmin(adminFlag);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAdmin");
    setToken(null);
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
